import script from "./FormFieldGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormFieldGroup.vue?vue&type=script&setup=true&lang=ts"

import "./FormFieldGroup.vue?vue&type=style&index=0&id=4649a412&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4649a412"]])

export default __exports__